export const Purchase_Vehicles = 'Purchase Vehicles';
